import {action} from 'mobx';

import apiCollectionGetContentStore from '../collection/apiCollectionGetContentStore';
import ApiBaseStore from '../common/apiBaseStore';
import {STATE_PENDING, STATE_FULFILLED, STATE_REJECTED} from '../../../constants/asyncConstants';
import {EXPIRE_TIME, EXPIRES_IN, EXPIRES_PENDING} from '../../../constants/storeConstants';
import serverApi from '../../../utils/serverApi';

/**
 * ApiContentUnPublishStore
 */
class ApiContentUnPublishStore extends ApiBaseStore {
  /**
   * Makes the api request.
   *
   * @param {number|string} contentId
   * @param {number|string} collectionId
   */
  @action makeRequest(contentId, collectionId) {
    if (!contentId) {
      this.state = STATE_REJECTED;
      this.error = new Error('Invalid content id given to contentUnPublish.');
      return;
    } else if (!collectionId) {
      this.state = STATE_REJECTED;
      this.error = new Error('Invalid collection id given to contentUnPublish.');
      return;
    }

    this.state = STATE_PENDING;
    this[EXPIRE_TIME] = Date.now() + EXPIRES_PENDING;

    serverApi.contentUnPublish(
      contentId,
      collectionId
    ).then(
      action('contentUnPublishSuccess', () => {
        this.error = null;
        this.state = STATE_FULFILLED;
        this.data = true;
        this[EXPIRE_TIME] = Date.now() + EXPIRES_IN;

        // Clear the collection cache.
        apiCollectionGetContentStore.refresh(collectionId, true);
      }),
      action('contentUnPublishError', (error) => {
        this.error = error;
        this.state = STATE_REJECTED;
        this.data = false;
      })
    );
  }
}

export default new ApiContentUnPublishStore();
